<template>
  <div class="home-container">
    <div class="banner">
      <el-carousel :interval="5000" arrow="always" height="600px">
        <el-carousel-item>
          <img
            src='../assets/images/banner/banner1.png'
            alt="公司首页 banner1"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src='../assets/images/banner/banner2.png'
            alt="公司首页 banner2"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src='../assets/images/banner/banner3.png'
            alt="公司首页 banner3"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src='../assets/images/banner/banner4.png'
            alt="公司首页 banner4"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src='../assets/images/banner/banner5.png'
            alt="公司首页 banner5"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="core-intro">
      <img style="position: absolute;left: 350px;top:  60px;" src='../assets/images/newfolder/45.png'  alt="">
      <div style="position: absolute;left: 445px;top: 270px;">
        <h3>使命</h3>
        <p>北京洁丽雅，让您的生活更健康！</p>
      </div>
      <div style="position: absolute;left: 750px;top:  270px;">
        <h3>核心价值观</h3>
        <p>乐观自信、勇于担当、信任协作、结果导向、客户满意 !</p>
      </div>
      <div style="position: absolute;left: 1250px;top:  270px;">
        <h3>愿景</h3>
        <p>服务全球，问鼎百年！</p>
      </div>
    </div>
    <div>
      <img src='../assets/images/background/xxx.png' />
    </div>
    <div class="product-highlight">
      <h2>视频展示</h2>
      
      <video width="60%" height="400" controls>
        <source
          src='../assets/images/video/company.mp4'
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
     
    </div> 
    <el-button plain size="medium" type="primary" round @click="$router.push('/news/video-center')">查看更多</el-button>
    <div class="product-highlight" >
      <h2>列车保洁</h2>
      <div class="highlight-list">
        <div class="highlight-item">
          <img src='../assets/images/train/1.jpg' alt="钥匙孔" />
          <p>钥匙孔</p>
        </div>
        <div class="highlight-item">
          <img src='../assets/images/train/2.jpg'  alt="车门把手" />
          <p>车门把手</p>
        </div>
        <div class="highlight-item">
          <img
            src='../assets/images/train/3.jpg'
            alt="擦拭站台10公分以下"
          />
          <p>擦拭站台10公分以下</p>
        </div>
      </div>
    </div>

    <div class="product-highlight">
      <h2>家政保洁</h2>
      <div class="highlight-list">
        <div class="highlight-item">
          <img src='../assets/images/services/home1.jpg' alt="星级服务" />
          <!-- <h3>4K智能摄像头</h3> -->
          <p>星级服务</p>
        </div>
        <div class="highlight-item">
          <img src='../assets/images/services/home2.jpg' alt="跑腿代购" />
          <p>跑腿代购</p>
        </div>
        <div class="highlight-item">
          <img src='../assets/images/services/home3.jpg' alt="家具陈列" />
          <p>家具陈列</p>
        </div>
      </div>
    </div>
    <div class="product-highlight news-center">
      <h2>新闻中心</h2>
      <div class="highlight-intro">
        遵纪守法，诚信经营，以质量赢得客户的满意
      </div>
      <div class="news-content">
        <div class="news-left">
          <img
            src="../assets/images/newfolder/news/1.jpg"
            alt="新闻动态"
            style="width: 70%; border-radius: 8px; margin-bottom: 15px"
          />
          <p>
            中国职业安全健康协会清洁服务从业者职业安全健康专业委员会成立大会顺利召开
          </p>
        </div>
        <div class="news-right" style="height: 280px; overflow-y: auto">
          <el-steps :space="100" direction="vertical" :active="14">
            <el-step>
              <template #title>
                <div class="step-left">2023/07/20 10:50</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('1')">
                    中国职业安全健康协会清洁服务从业者职业安全健康专业委员会成立大会顺利召开
                  </div>
                </div>
              </template>
            </el-step>
            <el-step>
              <template #title>
                <div class="step-left">2020/09/01 14:16</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('2')">
                    北京洁丽雅保洁有限公司（企业简介）
                  </div>
                </div>
              </template>
            </el-step>
            <el-step>
              <template #title>
                <div class="step-left">2020/08/28 09:37</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('3')">
                    紫外光车介绍
                  </div>
                </div>
              </template>
            </el-step>
            <el-step>
              <template #title>
                <div class="step-left">2020/08/27 14:28</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('4')">
                    洁丽雅北京电视台报道
                  </div>
                </div>
              </template>
            </el-step>
            <el-step>
              <template #title>
                <div class="step-left">2020/08/26 17:21</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('5')">
                    科技新星 LL20 抗菌剂 重磅发布
                  </div>
                  <div class="step-desc">LL20 抗菌剂 产品介绍 产品应用场景</div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/03/15 10:15</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('6')">
                    表扬信
                  </div>
                  <div class="step-desc">
                    闫雪丽这种品德高尚，拾金不昧的精神值得我们学习！
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/11 15:15</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('7')">
                    动卧列车变产房，齐心协力演绎和谐篇章
                  </div>
                  <div class="step-desc">
                    2016年10月30日早晨，由北京铁路局北京客运段京广动卧车队开出的深圳北—厦门北间D2350次列车上上，出现了温馨和谐的一幕。原来，列车刚刚驶过鲘门站后，车乘务员张晓飞一边向列车长石宝江报告，“1车3C坐席旅客龚淑敏称其孩子要生了”。一边安慰该旅客“别急！我们来给你想办法。”
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/11 15:09</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('8')">
                    神探“高姐”破案记
                  </div>
                  <div class="step-desc">
                    2014年12月1日下午15:00，由上海开往北京的G142次列车，正向北京方向疾驰。5号车的乘务员开始查票，刚才在手中明明拿着火车票及身份证却不翼而飞。列车员劝我不要着急，慢慢找，不会丢失。可是一个多小时过去了，几次翻遍全身和所有的包包都没有找到。
                    火车票丢失给出战带来麻烦，身份证丢失补办既费时间又耽误事，这是出门遇到最烦心的事。情急之中想找乘务员广播，看看是否有别的乘客捡拾。
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/18 11:28</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('9')">
                    组织2011年度乘服主管培训
                  </div>
                  <div class="step-desc">
                    一是参训人员交流发言，二是现任管理交流体会，三是管理常识辅导授课。
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/18 11:02</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('10')">
                    召开2009-2010年度工作会议
                  </div>
                  <div class="step-desc">
                    2010年7月4日至6日，北京洁丽雅保洁有限公司在北京“西翠宾馆”召开了2009-2010年度工作会议，会议以“夯实基础、做响品牌、增强实力”为主题，认真总结了2009年以来取得的各项工作成绩，查找了工作中存在的问题，对2010年的工作指明了方向。会议由办公室主任主持，总经理、副总经理做重要讲话，财务部、人力资源部、办公室领导出席会议并做报告，各区域经理、主管代表及办公室人员共计60余人参加了会议
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/18 11:32</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('11')">
                    组织乘服形体丶礼仪培训
                  </div>
                  <div class="step-desc">
                    塑造形体美 让乘服风景更美
                    为了塑造与提升动车乘服员的整体形象与气质，增强乘服从业人员的形体意识与服务意识，更好的满足铁路动车的乘服服务水准，人力资源部在遵循公司领导的指导原则下，于2011年6月19日下午在北京南站组织了关于乘服员形体训练的专题培训会，对公司六十余名乘服员、各线路乘服主管经行了集训。公司副总经理冉斌、助理王光亚、天津经理王耀光、人力资源部经理周康祥及人力资源部所有职员出席了培训
                  </div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/18 11:33</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('12')">
                    组织京沪高铁库内班长培训
                  </div>
                  <div class="step-desc">加强班组建设，提高基层管理能力</div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/18 11:34</div>
                <div class="step-right-group">
                  <div class="step-right" @click="goToNewsDetail('13')">
                    组织旅游活动
                  </div>
                  <div class="step-desc">组织管理人员旅游 调节员工心理环境</div>
                </div>
              </template> </el-step
            ><el-step>
              <template #title>
                <div class="step-left">2018/01/11 15:35</div>
                <div class="step-right-group" @click="goToNewsDetail('14')">
                  <div class="step-right">2008年8月1日，京津城际开通了!</div>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      // 数据可以根据实际需求进行调整
      highlightItems: [
        {
          title: "4K智能摄像头",
          desc: "星光级夜视+AI人形检测",
          imgSrc: "/images/highlight1.png",
        },
        {
          title: "人脸识别门禁",
          desc: "毫秒级识别+防照片/视频破解",
          imgSrc: "/images/highlight2.png",
        },
        {
          title: "智能报警系统",
          desc: "多重传感器+实时报警",
          imgSrc: "/images/highlight3.png",
        },
        {
          title: "云端管理平台",
          desc: "全场景数据分析与可视化",
          imgSrc: "/images/highlight4.png",
        },
      ],
      newsList: [
        {
          imagePath: `../assets/images/newfolder/news/20.png`,
          data: "20",
          title: "【北京洁丽雅保洁有限公司】 企业宣传片",
          time: "2023-07-25",
        },
        {
          imagePath: `../assets/images/newfolder/news/21.png`,
          data: "21",
          title: "洁丽雅保洁荣获年度优秀服务企业称号",
          time: "2023-08-10",
        },
        {
          imagePath: `../assets/images/newfolder/news/22.png`,
          data: "22",
          title: "高铁保洁新标准：细节决定服务品质",
          time: "2023-08-25",
        },
      ],
    };
  },
  methods: {
    goToNewsDetail(data) {
      const targetRoute = this.$router.resolve(`/news/detail${data}`);
      window.open(targetRoute.href, "_blank");
    },
  },
  mounted() {},
};
</script>
<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.home-container {
  max-width: 1920px;
  margin: 0 auto;
}

.banner img {
  width: 1920px;
  /* width: 500px; */
  height: 600px;
}

.core-intro {
  margin-bottom:300px;
  position: relative;
  padding: 60px 40px;
  text-align: center;
}

.core-intro h2 {
  color: #2c3e50;
  font-size: 2.2em;
  margin-bottom: 25px;
}

.core-intro p {
  color: #666;
  /* font-size: 1.1em; */
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

.product-highlight {
  padding: 60px 40px;
}

.highlight-intro {
  text-align: center;
  color: #999;
  font-size: 1.1em;
  margin-bottom: 30px;
}

.product-highlight h2 {
  text-align: center;
  color: #2c3e50;
  font-size: 2.2em;
  margin-bottom: 40px;
}

.highlight-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.highlight-item {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  padding-bottom: 0px;
  text-align: center;
  transition: all 0.3s ease;
}

.highlight-item:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.highlight-item img {
  height: 180px;
  margin-bottom: 20px;
}

.highlight-item h3 {
  color: #2c3e50;
  font-size: 1.4em;
  margin-bottom: 10px;
}

.highlight-item p {
  color: #666;
  font-size: 1.1em;
}

::v-deep .el-step {
  margin-bottom: 50px;
}

::v-deep .el-step__line {
  height: 153px;
}

.news-center {
  max-width: 1200px;
  margin: 0 auto;
}

.news-content {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.news-left {
  /* color: #ff0000; */
  flex: 1;
}

.news-right {
  flex: 1;
  height: 300px;
  overflow-y: auto;
}

.step-left {
  width: 120px;
  color: #666;
  font-size: 14px;
}

.step-right {
  cursor: pointer;
  font-size: 16px;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #2c3e50;
}

.step-right:hover {
  color: #a6db6b;
}


.step-right-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.step-desc {
  color: #999;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 450px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

::v-deep .el-step__title {
  align-items: center;
  gap: 16px;
}

.news-right::-webkit-scrollbar {
  width: 0;
}
::v-deep .el-step__head.is-finish{
  color: #a6db6b !important;
  border-color: #a6db6b !important;
}
/* ::v-deep .el-step__head.is-finish:hover {
  color: red !important;
  border-color: #a6db6b !important;
} */

 .step-right:hover ~ .news-left {
  color: #ff0000 !important;  /* 可按需修改颜色值 */
  border-color: #ff0000 !important;  /* 可按需修改边框颜色值 */
}
::v-deep .el-button--medium.is-round {
  padding: 15px  25px;
}
::v-deep .el-button--medium{
  font-size: 16px;
}
</style>
